import { defineSlotRecipe } from "@chakra-ui/react";

const pinInputSlotRecipe = defineSlotRecipe({
  className: "chakra-pin-input",
  slots: ["root", "control", "label", "input"],
  base: {
    root: {
      textStyle: "heading.standard"
    }
  },
  variants: {
    variant: {
      outline: {
        input: {
          bgColor: "input",
          borderRadius: "md",
          borderWidth: "md",
          borderColor: "lines",
          color: "base.700",
          textStyle: "heading.standard",
          fontWeight: "medium",
          focusVisibleRing: "inside",
          _placeholder: {
            color: "base.600"
          },
          _disabled: {
            layerStyle: "disabled",
            backgroundColor: "base.400",
            borderColor: "lines",
            cursor: "not-allowed",
            color: "text.soft"
          },
          _focus: {
            borderColor: "input.focus",
            focusRingColor: "input.focus"
          },
          _invalid: {
            borderColor: "error.element"
          },
          _focusVisible: {
            outline: "none"
          }
        }
      }
    },
    size: {
      "2xs": {},
      xs: {},
      sm: {},
      md: {},
      lg: {},
      xl: {},
      "2xl": {
        input: {
          width: "72px",
          height: "72px"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outline",
    size: "2xl"
  }
});

export default pinInputSlotRecipe;
